// Lazy loading
let lazyObserver = null;

function initLazyObserver() {
  if (!("IntersectionObserver" in window)) return;

  lazyObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const img = entry.target;
        const src = img.dataset.src;

        if (src) {
          img.addEventListener(
            "load",
            () => {
              if (window.lenis) {
                window.lenis.resize();
              }
            },
            { once: true },
          );

          img.src = src;
        }

        img.classList.remove("lazy");
        lazyObserver.unobserve(img);
      });
    },
    {
      rootMargin: "500px 0px",
    },
  );
}
function observeLazyImages() {
  if (!lazyObserver) return;

  document.querySelectorAll("img.lazy").forEach((img) => {
    lazyObserver.observe(img);
  });
}

// CSS viewport/header height variables
function setViewportVariables() {
  const header = document.getElementById("header");
  const headerHeight = header ? header.offsetHeight : 0;

  document.documentElement.style.setProperty("--h", `${window.innerHeight}px`);
  document.documentElement.style.setProperty("--m", `${headerHeight}px`);
}

// Wishlist

// Body scroll lock
function updateBodyScrollLock() {
  const categories = document.querySelector(".categories");
  document.body.classList.toggle("no-scroll", Boolean(categories && categories.classList.contains("active")));
}

// Mobile buy block
function initMobileBuyBlock() {
  const buyBlock = document.querySelector(".buy-block");
  if (!buyBlock) return;

  let hasActivated = false;
  const mobileQuery = window.matchMedia("(max-width: 768px)");

  function handleScroll() {
    if (!mobileQuery.matches) return;

    if (window.scrollY > 100 && !hasActivated) {
      buyBlock.classList.add("vissible");
      hasActivated = true;
    }

    if (window.scrollY === 0) {
      buyBlock.classList.remove("vissible");
      hasActivated = false;
    }
  }

  window.addEventListener("scroll", handleScroll, { passive: true });
}

// Breadcrumbs visibility on scroll

// Afterpay / Square styles

// Shop/menu actions
function initShopActions() {
  const links = document.querySelectorAll(".shop-link");
  const image = document.querySelector("#collection-image");

  if (image) {
    links.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        const img = link.dataset.image;
        if (img) image.src = img;
      });
    });
  }

  const drawer = document.querySelector("#cart-drawer");
  if (drawer) {
    const observer = new MutationObserver(() => {
      if (drawer.getAttribute("aria-hidden") === "false") {
        $(".discount").stop(true, true).slideUp(250);
      }
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });
  }

  document.querySelectorAll('.quick-add-btn[aria-disabled="true"]').forEach((btn) => btn.classList.add("soldie"));

  $(".shop-dropdown").hide();
  $(".shop-dropdown-images").addClass("opa");

  $(".shop").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    $("#cart-drawer").attr("aria-hidden", "true");

    $("#cart-drawer").stop(true, true).slideUp({
      duration: 300,
    });

    $(".shop-dropdown-images").toggleClass("opa");

    $(".shop-dropdown").stop(true, true).slideToggle({
      duration: 300,
    });
  });

  $(document).on("click", function (e) {
    if (!$(e.target).closest("header").length) {
      $(".shop-dropdown").stop(true, true).slideUp(250);
      $(".shop-dropdown-images").addClass("opa");
    }
  });

  $(".sold-out").hover(
    function () {
      $(this).text("Thank you");
    },
    function () {
      $(this).text("Sold Out");
    },
  );

  $(".read-toggle").on("click", function () {
    const $btn = $(this);
    const $desc = $btn.next(".description");
    const isExpanded = $btn.attr("aria-expanded") === "true";

    if (isExpanded) {
      $desc.slideUp(100, function () {
        $desc.attr("data-collapsed", "true");
      });
      $btn.text("Read more").attr("aria-expanded", "false");
    } else {
      $desc.slideDown(100, function () {
        $desc.attr("data-collapsed", "false");
      });
      $btn.text("Read less").attr("aria-expanded", "true");
    }
  });

  $(".toggle-btn").on("click", function () {
    const $block = $(this).closest(".toggle-block");
    const $icon = $(this).find(".icon");

    $(".toggle-block.active")
      .not($block)
      .each(function () {
        $(this).removeClass("active");
        $(this).find(".toggle-content").slideUp(200);
        $(this).find(".icon").text("+");
      });

    $block.toggleClass("active");
    $block.find(".toggle-content").slideToggle(200);
    $icon.text($block.hasClass("active") ? "–" : "+");
  });
}

$(document).on("click", ".menu-open-movil", function (e) {
  e.preventDefault();

  console.log("click detectado");

  const isOpen = $(this).toggleClass("active").hasClass("active");

  $("body").toggleClass("no-scroll", isOpen);
  $(".menu-pop-up").toggleClass("active", isOpen);

  $(this).text(isOpen ? "CLOSE" : "MENU");

  console.log("texto actual:", $(this).text());
});

// Init
$(document).ready(function () {
  initLazyObserver();
  observeLazyImages();
  setViewportVariables();

  updateBodyScrollLock();
  initMobileBuyBlock();
  initShopActions();
});

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll("body *:not(script):not(style)");

  elements.forEach((el) => {
    el.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && /\d/.test(node.textContent)) {
        const wrapper = document.createElement("span");

        wrapper.innerHTML = node.textContent.replace(/(\d+)/g, '<span class="small-caps-number">$1</span>');

        node.replaceWith(...wrapper.childNodes);
      }
    });
  });
});

window.addEventListener("resize", setViewportVariables);
